import { DataBean } from "../DataBean";

export class EntryForUBLInvoice extends DataBean {



    public async createFixedAssetEntryForUBLInvoice(idUBLInvoice: any, issueDate: any, idAccountantConcept: any, recordDate: any, idStore: any, defaultType: any, defaultIDProduct: any, idAdquisitionContract: any, adquisitionContractDate: any, userOtherDocumentFactory: any, documentClassFactory: any, idEmployee: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.accountant.AccountantDocument_createFixedAssetEntryForUBLInvoice_Number_java.util.Date_Number_java.util.Date_Number_Number_Number_Number_java.util.Date_Boolean_String_Number", [idUBLInvoice, issueDate, idAccountantConcept, recordDate, idStore, defaultType, defaultIDProduct, idAdquisitionContract, adquisitionContractDate, userOtherDocumentFactory, documentClassFactory, idEmployee]);
    }

}
